module.exports = __webpack_public_path__ + "img/ava.a18e66a1.png";